<div class="offline-region" role="status" aria-live="polite">
  @if (visible()) {
    <div class="offline-pill" [class.is-back]="!offline()">
      @if (offline()) {
        <mat-icon aria-hidden="true">cloud_off</mat-icon>
        <span>
          {{ 'offline.banner' | translate }}
          @if (savedSince(); as since) {
            <span class="offline-since">{{ 'offline.savedAt' | translate : { time: (since | date:'short') } }}</span>
          }
        </span>
      } @else {
        <mat-icon aria-hidden="true">cloud_done</mat-icon>
        <span>{{ 'offline.back' | translate }}</span>
      }
    </div>
  }
</div>
